import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api/apiClient';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [resetUrl, setResetUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await apiClient.post('/auth/forgot-password', { email });
      setResetUrl(res.data.resetUrl || '');
      setSubmitted(true);
    } catch (e) {
      setError(e.response?.data?.error || 'Request failed. Please try again.');
    } finally { setLoading(false); }
  };

  const copy = () => {
    navigator.clipboard.writeText(resetUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.icon}>🔑</div>
        <h2 style={styles.title}>Forgot Password</h2>

        {!submitted ? (
          <>
            <p style={styles.desc}>Enter your email address and we'll generate a password reset link.</p>
            {error && <div style={styles.error}>{error}</div>}
            <form onSubmit={handleSubmit} style={styles.form}>
              <label style={styles.label}>Email Address</label>
              <input
                type="email"
                required
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                style={styles.input}
              />
              <button type="submit" disabled={loading} style={styles.btn}>
                {loading ? 'Generating…' : 'Generate Reset Link'}
              </button>
            </form>
          </>
        ) : (
          <>
            <div style={styles.success}>
              <p style={{ margin: '0 0 0.75rem 0', fontWeight: '600' }}>Reset link generated!</p>
              <p style={{ margin: '0 0 1rem 0', fontSize: '0.875rem', color: '#475569' }}>
                Use this link to reset your password. Share it with your admin or use it yourself.
                This link expires in 24 hours.
              </p>
              <div style={styles.urlBox}>
                <span style={styles.urlText}>{resetUrl}</span>
              </div>
              <button onClick={copy} style={styles.copyBtn}>
                {copied ? '✅ Copied!' : '📋 Copy Link'}
              </button>
              <div style={{ marginTop: '1rem' }}>
                <a href={resetUrl} style={styles.useNow}>Use this link now →</a>
              </div>
            </div>
          </>
        )}

        <div style={styles.footer}>
          <Link to="/login" style={styles.backLink}>← Back to Login</Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f1f5f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
  },
  card: {
    background: '#fff',
    borderRadius: '1rem',
    padding: '2.5rem',
    width: '100%',
    maxWidth: '460px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
    textAlign: 'center',
  },
  icon: { fontSize: '2.5rem', marginBottom: '0.75rem' },
  title: { margin: '0 0 0.5rem 0', fontSize: '1.5rem', fontWeight: '700', color: '#1e293b' },
  desc: { margin: '0 0 1.5rem 0', color: '#64748b', fontSize: '0.9rem', textAlign: 'left' },
  error: {
    background: '#fef2f2',
    border: '1px solid #fecaca',
    color: '#dc2626',
    padding: '0.625rem 0.875rem',
    borderRadius: '0.5rem',
    fontSize: '0.875rem',
    marginBottom: '1rem',
    textAlign: 'left',
  },
  form: { display: 'flex', flexDirection: 'column', gap: '0.75rem', textAlign: 'left' },
  label: { fontSize: '0.8rem', fontWeight: '600', color: '#374151' },
  input: {
    padding: '0.625rem 0.875rem',
    border: '1.5px solid #e2e8f0',
    borderRadius: '0.5rem',
    fontSize: '0.95rem',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  btn: {
    padding: '0.75rem',
    background: '#6366f1',
    color: '#fff',
    border: 'none',
    borderRadius: '0.5rem',
    fontSize: '0.95rem',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '0.25rem',
  },
  success: { textAlign: 'left' },
  urlBox: {
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: '0.5rem',
    padding: '0.75rem',
    wordBreak: 'break-all',
    fontSize: '0.8rem',
    color: '#334155',
    marginBottom: '0.75rem',
  },
  urlText: { fontFamily: 'monospace' },
  copyBtn: {
    padding: '0.5rem 1.25rem',
    background: '#6366f1',
    color: '#fff',
    border: 'none',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: '600',
  },
  useNow: { color: '#6366f1', textDecoration: 'none', fontWeight: '600', fontSize: '0.875rem' },
  footer: { marginTop: '1.5rem', borderTop: '1px solid #f1f5f9', paddingTop: '1rem' },
  backLink: { color: '#6366f1', textDecoration: 'none', fontSize: '0.875rem', fontWeight: '500' },
};
